export const validation = {
  titleMaxChar: 100,
  paragraphMaxChar: 50,
  paragraphRightMaxChar: 200
}
